/*
 * @providesModule MaintenancePopup
 */

import React, {useEffect} from 'react';
import {Keyboard, StyleSheet, View} from 'react-native';
import SkillzSVG from 'SkillzSVG';
import Label from 'Label';
import * as CommonStyles from 'CommonStyles';
import styles from 'MaintenancePopupStyles';

interface MaintenancePopupProps {
  isVisible: boolean;
  heading: string;
  subheading: string;
}

const MaintenancePopup = ({isVisible, heading, subheading}: MaintenancePopupProps) => {
  useEffect(() => {
    if (isVisible) {
      Keyboard.dismiss();
    }
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <View style={StyleSheet.absoluteFill} pointerEvents="box-none">
      <View style={styles.overlay}>
        <View style={styles.logoContainer}>
          <SkillzSVG source="ic_skillz_s.svg" style={styles.logoIcon} />
          <SkillzSVG
            source="skillz_logo_wordmark_dark.svg"
            style={styles.logoWordmark}
            tintColor={CommonStyles.textWhite.color}
          />
        </View>
        <View style={styles.container}>
          <SkillzSVG
            source="maintenance.svg"
            style={styles.maintenanceImage}
          />
          <Label style={styles.heading}>{heading}</Label>
          <Label style={styles.subheading}>{subheading}</Label>
        </View>
      </View>
    </View>
  );
};

export default MaintenancePopup;
